// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"71":"03d54f6e","101":"43b3aeb7","254":"fd0bfb64","272":"af7f7c67","443":"a5c655e8","519":"4c65fb98","736":"cc93b849","924":"0591838b","977":"01f46c36"}[chunkId] + ".js";
};